export enum RolesEnum {
  Customer = 'Customer',
  Admin = 'Admin',
}
